export default __webpack_public_path__ + "static/media/160x90.5ee2f6b1.jpg";